import {
  hasCompleteQueryData,
  throwOnQueryError,
} from 'ZalamoLibrary/src/lib/core/graphql/complete-query-data';

import { Observable, filter, map, pipe, startWith, switchMap } from 'rxjs';

import { Pipe, PipeTransform } from '@angular/core';

import { GetAvailablePrintsConfigGQL } from '../../product-editor/graphql';
import { TranslationLoaderService } from '@ui/nls/translations/translation-loader.service';

@Pipe({
  name: 'printPaperLabel',
  standalone: false,
})
export class PrintPaperLabelPipe implements PipeTransform {
  constructor(
    private availableFormats: GetAvailablePrintsConfigGQL,
    private translationLoaderService: TranslationLoaderService,
  ) {}

  transform(printPaperId: string, ...args: unknown[]): Observable<string> {
    return this.availableFormats.watch({}).valueChanges.pipe(
      throwOnQueryError,
      filter(hasCompleteQueryData),
      map((result) => result.data['availablePrintConfigs']['papers']),
      switchMap((formats) => {
        const label = formats.find(
          (printFormat) => printFormat.printPaperId === printPaperId,
        )?.label;
        return this.translationLoaderService.onChange().pipe(
          map(() =>
            this.translationLoaderService.translate('productFront', label),
          ),

          startWith(
            this.translationLoaderService.translate('productFront', label),
          ),
        );
      }),
    );
  }
}
